import { render, staticRenderFns } from "./DialogFile.vue?vue&type=template&id=148a2826"
import script from "./DialogFile.vue?vue&type=script&lang=js"
export * from "./DialogFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports